import SwiperImage from "../common-components/SwiperImage";
import { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { notAvailableImg } from "../../constants/common-constants";
import { useLocation } from "react-router-dom";
import VehicleDetailsZoomableImageModal from "../VehicleDetailsZoomableImageModal/VehicleDetailsZoomableImageModal";
import SVGSelector from "../common-components/SVGSelector";
import { useSelector } from "react-redux";
import { getEdgeClass } from "../../utils";

const VehicleImageSwiper = ({ vehicleDetails = [] }) => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});
  const { edge = false } = useSelector((state) => state?.uiConfig) || {};
  const { search } = useLocation();
  const handleThumbnailClick = (index) => {
    if (swiperInstance) {
      swiperInstance.slideTo(index);
    }
  };
  useEffect(() => {
    return () => {
      setLoadedImages({});
    };
  }, [search]);

  useEffect(() => {
    setSelectedIndex(0);
    if (swiperInstance && swiperInstance.slideTo) {
      swiperInstance.slideTo(0, 0);
    }
    //eslint-disable-next-line
  }, [vehicleDetails, search]);

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [vehicleItem, setVehicleItem] = useState(null);

  const handleModalToggle = (item) => {
    setVehicleItem(item);
    setIsModalVisible(!isModalVisible);
  };
  const thumbnailSwiperRef = useRef(null);

  useEffect(() => {
    if (thumbnailSwiperRef?.current) {
      thumbnailSwiperRef?.current?.navigation?.init();
      thumbnailSwiperRef?.current?.navigation?.update();
    }
  }, []);
  return (
    <>
      <div
        className="w-[60%] max-[1299px]:w-2/4 max-lg:w-full"
        key={vehicleDetails?.length + 1}
      >
        <div className={`swiper mySwiper2 ${getEdgeClass(edge, "rounded-md")}`}>
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <SwiperImage
                key={vehicleDetails?.length + 1}
                vehicleDetails={vehicleDetails}
                pagination={false}
                mouseWheel={false}
                spaceBetween={0}
                slidesPerView={1}
                setSwiperInstance={setSwiperInstance}
                handleModalToggle={handleModalToggle}
              />
            </div>
          </div>
        </div>
        <div className="pt-5" key={vehicleDetails?.length + 1}>
          <Swiper
            ref={thumbnailSwiperRef}
            spaceBetween={12}
            slidesPerView="auto"
            freeMode={true}
            mousewheel={true}
            speed={300}
            key={vehicleDetails?.length + 1}
            navigation={{
              nextEl: ".thumbnail-swiper-next-btn",
              prevEl: ".thumbnail-swiper-prev-btn",
            }}
            modules={[Navigation]}
          >
            {vehicleDetails
              // ?.filter((veh) => veh?.type === "Image")
              ?.map((item, index) => (
                <SwiperSlide key={index} style={{ width: "auto" }}>
                  <div className="h-[9rem] w-[12.5rem] relative max-sm:h-[6rem] max-sm:w-[8rem]">
                    {!loadedImages[index] && (
                      <div
                        className={`absolute top-0 left-0 h-full w-full bg-gray-300 animate-pulse ${getEdgeClass(edge)}`}
                      ></div>
                    )}
                    <img
                      className={`${getEdgeClass(edge)} h-full w-full object-cover cursor-pointer transition-opacity duration-300 ${
                        loadedImages[index] ? "opacity-100" : "opacity-0"
                      } ${
                        index === selectedIndex && loadedImages[index]
                          ? "border-4 primary-color"
                          : ""
                      }`}
                      src={
                        item?.downloadUrl + "&w=300&h=220" || notAvailableImg
                      }
                      alt="car"
                      onClick={() => {
                        setSelectedIndex(index);
                        handleThumbnailClick(index);
                      }}
                      onError={(e) => {
                        e.target.src = notAvailableImg;
                      }}
                      onLoad={() => handleImageLoad(index)}
                    />
                  </div>
                </SwiperSlide>
              ))}
            <button className="thumbnail-swiper-prev-btn">
              <SVGSelector
                name="arrow-left-svg"
                pathFill={"var(--text-white-black)"}
              />
            </button>
            <button className="thumbnail-swiper-next-btn">
              <SVGSelector
                name="arrow-right-svg"
                pathFill={"var(--text-white-black)"}
              />
            </button>
          </Swiper>
        </div>
      </div>
      <VehicleDetailsZoomableImageModal
        isVisible={isModalVisible}
        handleModalToggle={handleModalToggle}
        edge={edge}
        vehicleItem={vehicleItem}
      />
    </>
  );
};
export default VehicleImageSwiper;
